import AlarmsManagerIcon from './component'

export default AlarmsManagerIcon